/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Simple scope ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type SimpleScopeRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const SimpleScopeRatingEnum = {
    Low: 'Low' as SimpleScopeRatingEnum,
    Medium: 'Medium' as SimpleScopeRatingEnum,
    High: 'High' as SimpleScopeRatingEnum,
    VeryHigh: 'Very High' as SimpleScopeRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

